import styled, { css } from "styled-components"

import Pc from "~/components/atoms/Pc"
import Sp from "~/components/atoms/Sp"
import Typography from "~/components/atoms/Typography"
// import Link from "~/components/atoms/Link"
import { Container as _Container } from "~/components/layouts/Container"
import { Color, IsMobile, IsPC, LineHeight, RadiusSize, Shadow, SpacingSize, TextSize } from "~/consts/style-mixins"
import { staticPath } from "~/services/helper"

interface Props {
  job: string
}

const Consultation = ({ job }: Props) => {
  return (
    <Container size="Large">
      <Pc>
        <img src={staticPath("/static/images/course/consultation-pc.svg")} />
      </Pc>
      <Sp>
        <img src={staticPath("/static/images/course/consultation-sp.svg")} />
      </Sp>
      <p className="heading">{job}として一歩踏み出す無料の個別相談会</p>
      <p className="supplement">講師の方に講座やキャリアについて気軽に相談してみよう</p>
      <StyledConsultation>
        <StyledConsultationItem>
          <StyledConsultationItemIcon src={staticPath("/static/images/course/course_clock.svg")} />
          <StyledConsultationItemTextArea>
            <StyledConsultationItemTextAreaHeading>30分程度のオンライン面談</StyledConsultationItemTextAreaHeading>
            <StyledConsultationItemTextAreaCaption type="Body">
              忙しい時期でもスキマ時間で気軽に実施できます
            </StyledConsultationItemTextAreaCaption>
          </StyledConsultationItemTextArea>
        </StyledConsultationItem>
        <StyledConsultationItem>
          <StyledConsultationItemIcon src={staticPath("/static/images/course/course_light.svg")} />
          <StyledConsultationItemTextArea>
            <StyledConsultationItemTextAreaHeading>あなたに合う学び方を提案</StyledConsultationItemTextAreaHeading>
            <StyledConsultationItemTextAreaCaption type="Body">
              現在のスキルや経験に合った講座の進め方を考えます
            </StyledConsultationItemTextAreaCaption>
          </StyledConsultationItemTextArea>
        </StyledConsultationItem>
        <StyledConsultationItem>
          <StyledConsultationItemIcon src={staticPath("/static/images/course/course_message.svg")} />
          <StyledConsultationItemTextArea>
            <StyledConsultationItemTextAreaHeading>キャリア相談も実施</StyledConsultationItemTextAreaHeading>
            <StyledConsultationItemTextAreaCaption type="Body">
              就活や{job}の仕事ついての相談にもお応えします
            </StyledConsultationItemTextAreaCaption>
          </StyledConsultationItemTextArea>
        </StyledConsultationItem>
      </StyledConsultation>
      <StyledConsultationCaution type="Body">
        ※無理な勧誘は一切行いませんので安心してお申し込みください。
      </StyledConsultationCaution>
    </Container>
  )
}

const Container = styled(_Container)`
  ${IsPC(css`
    padding: 96px 16px;
  `)}
  ${IsMobile(css`
    padding: 48px 16px;
  `)}
  .heading {
    font-size: ${TextSize["2XL"]}px;
    font-weight: bold;
    line-height: ${LineHeight.S}%;
    margin-top: ${SpacingSize["4XL"]}px;
    ${IsMobile(css`
      font-size: 20px;
      margin-top: 32px;
    `)}
  }
  .supplement {
    font-size: ${TextSize.M}px;
    line-height: ${LineHeight.L}%;
    color: ${Color.Gray};
    margin-top: ${SpacingSize["3XS"]}px;
    ${IsMobile(css`
      margin-top: 8px;
    `)}
  }
`
const StyledConsultation = styled.div`
  display: flex;
  margin-top: ${SpacingSize["4XL"]}px;
  ${IsMobile(css`
    flex-direction: column;
    margin-top: 32px;
  `)}
`
const StyledConsultationItem = styled.div`
  width: calc(33% - 32px);
  ${Shadow.Deep};
  border-radius: ${RadiusSize.Medium}px;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: ${SpacingSize["4XL"]}px ${SpacingSize.XL}px ${SpacingSize["2XL"]}px;
  margin-bottom: ${SpacingSize.L}px;
  ${IsMobile(css`
    width: 100%;
    margin-bottom: 24px;
  `)}
  &:not(:first-child) {
    margin-left: 48px;
    ${IsMobile(css`
      margin-left: 0;
    `)}
  }
`
const StyledConsultationItemIcon = styled.img`
  width: auto;
  height: 80px;
`
const StyledConsultationItemTextArea = styled.div`
  margin-top: ${SpacingSize["2XL"]}px;
  text-align: center;
`

const StyledConsultationItemTextAreaHeading = styled.p`
  font-size: ${TextSize.L}px;
  font-weight: bold;
  line-height: ${LineHeight.S}%;
`
const StyledConsultationItemTextAreaCaption = styled(Typography)`
  color: ${Color.Gray};
  margin-top: ${SpacingSize["3XS"]}px;
`

const StyledConsultationCaution = styled(Typography)`
  color: ${Color.LightGray};
  margin-top: ${SpacingSize.XL}px;
  text-align: center;
  ${IsMobile(css`
    margin-top: 0;
  `)}
`

export default Consultation
